import { useTranslation } from 'next-i18next';
import JoinExpUSHeroEs from './hero-es';
import JoinExpUSHeroEn from './hero-us';
import JoinExpUSHeroFr from './hero-fr';
import { SiteLanguage } from 'types/locales';

function JoinExpUSHero({ downArrowRef }: { downArrowRef: React.RefObject<HTMLDivElement> }) {
  const { i18n } = useTranslation();

  switch (i18n.language) {
    case SiteLanguage.English:
    case SiteLanguage.EnglishCA:
      return <JoinExpUSHeroEn downArrowRef={downArrowRef} />;
    case SiteLanguage.Spanish:
      return <JoinExpUSHeroEs downArrowRef={downArrowRef} />;
    case SiteLanguage.French:
    case SiteLanguage.FrenchCA:
      return <JoinExpUSHeroFr downArrowRef={downArrowRef} />;
    default:
      return <JoinExpUSHeroEn downArrowRef={downArrowRef} />;
  }
}

export default JoinExpUSHero;
